export function checkScrollPoints(elements, scrollTop, offset, fn1, fn2, exceptionElement) {
    let $positions = [];
    let exceptionStart = exceptionElement && exceptionElement.length > 0 ? $(exceptionElement).offset().top - offset : $("body").innerHeight();

    $(elements).each(function () {
        let $top = $(this).offset().top - offset;
        let $bottom = $top + $(this).innerHeight() - offset;

        $positions.push({start: $top, end: $bottom});
    });

    for (let i = 0; i < $positions.length; i++) {

        if (scrollTop >= $positions[i]["start"] && scrollTop <= $positions[i]["end"] && scrollTop < exceptionStart) {
            fn1(i);

            break;
        } else {
            fn2(i);
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/check-scroll-points.js